module.exports = __webpack_public_path__ + "static/media/right-indent-alt.d58d932b.svg";